import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import pricing from './data/pricing.json'
import services from './services/services.js'
import { LocationService } from './services/location-service.js'
import is from 'is_js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: !!Cookies.get('RB_SESSION'),
    locationService: new LocationService(),
    toRoute: {},
    userData: {},
    pricingData: pricing,
    pricingReceived: false,
    paymentToken: '',
    submitting: false,
    modalOpen: false
  },
  mutations: {
    setUserData (state, data) {
      state.userData = data
    },
    setPricingData (state, data) {
      state.pricingReceived = true
      state.pricingData = data
    },
    saveNextRoute (state, data) {
      state.toRoute = data
    },
    clearUserData (state) {
      state.userData = {}
    },
    paymentToken (state, token) {
      state.paymentToken = token
    },
    submitting (state, submitting) {
      state.submitting = submitting
    },
    modalOpen (state, status) {
      state.modalOpen = status
    }
  },
  actions: {
    prepareUserData ({ commit, state }, forceRefresh) {
      return new Promise((resolve, reject) => {
        if (!services.objIsEmpty(state.userData) && !forceRefresh) {
          resolve()
        } else {
          this.$http.get(this.ENV.apiBaseUrl + '/web/account/details').then((response) => {
            commit('setUserData', response.data)
            resolve()
          }).catch(error => {
            if (error.response) {
              if ([401, 429].indexOf(error.response.status) > -1) {
                if (is.ios()) Cookies.remove('RB_SESSION', {domain: '.remembear.com'})
                window.location.href = this.ENV.apiBaseUrl + '/web/account/logout'
              }
            }
            reject(error)
          })
        }
      })
    },
    preparePricingDetails ({ commit, state }, coupon) {
      return new Promise((resolve, reject) => {
        if (state.pricingReceived) {
          resolve()
        } else {
          this.$http.get(this.ENV.paymentBaseUrl + '/pricing', {
            params: {
              app: 'REMEMBEAR'
            }
          }).then(response => {
            commit('setPricingData', response.data)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
    getPaymentToken ({ commit }) {
      return new Promise((resolve, reject) => {
        this.$http.get(this.ENV.apiBaseUrl + '/web/account/paymentToken').then((response) => {
          commit('paymentToken', response.data)
          resolve()
        }).catch(error => {
          reject()
        })
      })
    },
    submitting ({commit}, submitting) {
      commit('submitting', submitting)
    },
    modalOpen ({commit}, status) {
      commit('modalOpen', status)
    }
  },
  getters: {
    nextRoute: state => {
      return state.toRoute
    },
    userData: state => {
      return state.userData
    },
    pricingData: state => {
      return state.pricingData
    },
    isLoggedIn: state => {
      return state.isLoggedIn
    },
    paymentToken: state => {
      return state.paymentToken
    },
    submitting: state => {
      return state.submitting
    },
    modalOpen: state => {
      return state.modalOpen
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js